import { useTranslation } from "react-i18next";

import {
  Dropdown,
  DropdownButton,
  DropdownMenu,
  DropdownMenuItem
} from "@unified-checkout/design-system";

import { useCheckoutCustomizationStore } from "@app/dashboard/store/checkout-customization";
import { fontOptions, styleOptions } from "../../../../utils";
import "../../../../shared.scss";


export const BrandStyling = () => {
  const { t } = useTranslation();

  const {
    isFetched,
    customizationData,
    setCustomizationData
  } = useCheckoutCustomizationStore();
  const { branding } = customizationData;
  const { font, style } = branding;

  const brandingStyling = [
    {
      key: 'font',
      label: t('innerLayout.checkoutCustomizationPage.tabs.branding.sections.font.title'),
      placeholder: '',
      options: fontOptions
    },
    {
      key: 'style',
      label: t('innerLayout.checkoutCustomizationPage.tabs.branding.sections.style.title'),
      placeholder: '',
      options: styleOptions
    }
  ];

  const selectedStyles: Record<string, Record<string, string>> | undefined = isFetched ? {
    font: {
      label: font.label || fontOptions[0].label,
      value: font.value || fontOptions[0].value
    },
    style: {
      label: style.label || styleOptions[0].label,
      value: style.value || styleOptions[0].value
    }
  } : undefined;

  const changeHandler = (key: string, value: string, label: string) => {

    const labelValuePair = { label, value };

    setCustomizationData(prevData => ({
      ...prevData,
      branding: {
        ...prevData.branding,
        [key]: labelValuePair
      }
    }));
  };

  return (
    <>
      {
        brandingStyling.map((item, index) =>
          <div
            key={`branding-style-dd-${index}`}
          >
            <Dropdown
              label={item.label}
              closeOnClickOutside
            >
              <DropdownButton
                type="input"
                placeholder={item.placeholder}
                text={selectedStyles?.[item.key].label}
              />

              <DropdownMenu
                verticalPlacement="auto"
              >
                {
                  item.options.map((option, i) =>
                    <DropdownMenuItem
                      key={`branding-style-menu-item-${index}-${i}`}
                      text={option.label}
                      onClickHandler={() => changeHandler(item.key, option.value, option.label)}
                      selected={selectedStyles?.[item.key].value === option.value}
                    />
                  )
                }
              </DropdownMenu>
            </Dropdown>
          </div>
        )
      }
    </>
  )
};